import React from 'react';
import {useSuspenseQuery} from '@tanstack/react-query';
import {getQueryKey} from '@shared/queryKeyMap';
import {AggregatedSestData, CreatedMaintenanceRecordRequest} from '@di-shared/api/di/__generated';
import clsx from 'clsx';
import {diApi} from '@di-shared/api/di';
import environmentStore from '@di-shared/features/environment/environmentStore';

interface SestExchangeSelectGroupProps {
  toggleSestCode: (sestCode: CreatedMaintenanceRecordRequest.sestCode) => void;
  isCheckedSest: (sestCode: CreatedMaintenanceRecordRequest.sestCode) => boolean;
  vin: string;
}

function SestExchangeSelectGroup({toggleSestCode, isCheckedSest, vin}: SestExchangeSelectGroupProps) {
  const ccid = environmentStore.getState().ccid;
  const {data: sestData} = useSuspenseQuery({
    queryKey: [getQueryKey(diApi.maintenancesSestController.getAggregatedSestList1), vin, ccid],
    queryFn: () =>
      diApi.maintenancesSestController.getAggregatedSestList1({
        vin,
        ccid,
      }),
    select: (data) => data.data?.sests as AggregatedSestData[],
  });
  return (
    <div className="box_outline_group">
      {sestData.map(({sestName, sestCode}) => (
        <div
          key={sestName}
          className={clsx('select_box', 'select_box_outline', {
            'is-selected': isCheckedSest(sestCode as CreatedMaintenanceRecordRequest.sestCode),
          })}
        >
          <input
            type="checkbox"
            id={sestName}
            className="input"
            onChange={() => toggleSestCode(sestCode as CreatedMaintenanceRecordRequest.sestCode)}
            checked={isCheckedSest(sestCode as CreatedMaintenanceRecordRequest.sestCode)}
          />
          <label
            className="label"
            htmlFor={sestName}
          >
            <span className="text">{sestName}</span>
          </label>
        </div>
      ))}
    </div>
  );
}

export default SestExchangeSelectGroup;

export function SestExchangeSelectGroupLoading() {
  return (
    <div className="box_outline_group">
      <div
        className="select_box select_box_outline skeleton"
        style={{height: 70}}
      />
      <div
        className="select_box select_box_outline skeleton"
        style={{height: 70}}
      />
      <div
        className="select_box select_box_outline skeleton"
        style={{height: 70}}
      />
      <div
        className="select_box select_box_outline skeleton"
        style={{height: 70}}
      />
      <div
        className="select_box select_box_outline skeleton"
        style={{height: 70}}
      />
    </div>
  );
}
